// type 1是一级， 2是有弹出框
import { SYSTEM_INFO, ENV, IS_GLOBAL } from '@/pages/home/_config/config';
import newTagIcon from '@/pages/home/assets/svg/exploreHeader/new-tag.svg';

export type navType =
  | 'dashboard'
  | 'dashboard_pc'
  | 'globalpedia'
  | 'globalpedia_pc'
  | 'homepage'
  | 'homepage_pc'
  | 'intelligence'
  | 'intelligence_pc'
  | 'opinion'
  | 'opinion_pc'
  | 'benchmark'
  | 'benchmark_pc';

export type navItemType = {
  href: string;
  name: string;
  rbac: string;
  title: string;
  title_cn: string;
  children?: any[];
};

export type DashGameType = {
  game_code: string;
  has_permissions: boolean;
  unifiedid: string;
};

export type SearchGameType = {
  company_id: string;
  company_name: string;
  console_id: string;
  cover: string;
  dashboard: number;
  entity_image: string;
  entity_name: string;
  entity_name_ch: string;
  entity_name_en: string;
  entity_type: string;
  game_code: string;
  game_id: string;
  game_name: string;
  game_phase: string;
  index_buildtime: string;
  intelligence: number;
  location_identifiers_country: string;
  match_score: string;
  metrics: any[];
  opinion: number;
  sortNum: number;
  other_name: string;
  pc_id: string;
  phase_type: string;
  publisher: string;
  publisher_id: string;
  release_time: string;
  opinionGameId?: string;
  combine_id?: string;
  manual_score?: string;
  is_top?: boolean;
  isTop?: boolean;
  secondaryOrder?: number;
  similarity?: number;
};

export type SearchGameAcclistType = {
  combineId?: string;
  combineList?: SearchGameType[];
  sortNum?: number;
  matchScore?: string;
};

// GPOP新手指引文档链接
const GPOP_BEGINNER_GUIDE_DOC_URL = 'https://doc.weixin.qq.com/doc/w3_ABQA3AY2AD4O1naFnvDTxaOLvFAuO';

export const baseNavListConfig = {
  homepage: {
    useNewStyle: true,
    icon: 'menu-home',
    actionIcon: 'home-icon',
    sys: '/home',
    rbac: 'homepage',
  },
  dashboard: {
    icon: 'menu-merit',
    actionIcon: 'merit',
    subIcon: 'continuous-upward',
    useNewStyle: SYSTEM_INFO.dashboard[ENV],
    bubbleIntroMessageId: 'dhh_nav_bubble_dashboard_intro',
    sys: '/dashboard',
    rbac: 'dashboard',
  },
  intelligence: {
    icon: 'menu-intelligence',
    actionIcon: 'intelligence',
    subIcon: 'intelligence',
    useNewStyle: SYSTEM_INFO.intelligence[ENV],
    bubbleMessageId: 'dhh_nav_bubble_intelligence',
    bubbleIntroMessageId: 'dhh_nav_bubble_intelligence_intro',
    sys: '/intelligence',
    rbac: 'intelligence',
  },
  opinion: {
    subIcon: 'public',
    useNewStyle: SYSTEM_INFO.opinion[ENV],
    // bubbleMessageId: 'dhh_nav_bubble_opinions',
    bubbleIntroMessageId: 'dhh_nav_bubble_opinions_intro',
    sys: '/opinion',
    rbac: 'opinion',
  },
  marketing: {
    subIcon: 'market-hub',
    href: '/marketing/Memes',
    useNewStyle: SYSTEM_INFO.opinion[ENV],
    sys: '/marketing',
    rbac: 'market',
    title: 'Marketing Hub',
    name: 'Marketing Hub',
    title_cn: '市场专区',
  },
  globalpedia: {
    icon: 'menu-manage',
    actionIcon: 'manage-icon',
    subIcon: 'trend-manage',
    useNewStyle: SYSTEM_INFO.globalpedia[ENV],
    // bubbleMessageId: 'dhh_nav_bubble_globalpedia',
    bubbleIntroMessageId: 'dhh_nav_bubble_globalpedia_intro',
    sys: '/g-pop',
    rbac: 'globalpedia',
    title_cn: 'G-POP',
  },
  managementdashboard: {
    // icon: 'menu-manage',
    // actionIcon: 'manage-icon',
    subIcon: 'strategic',
    useNewStyle: SYSTEM_INFO.managementdashboard[ENV],
    // bubbleMessageId: 'dhh_nav_bubble_globalpedia',
    // bubbleIntroMessageId: 'dhh_nav_bubble_globalpedia_intro',
    sys: '/strategic',
    href: '/strategic/home',
    name: 'Management Dashboard',
    rbac: 'mgmt_pc',
    title: 'Management Dashboard',
    title_cn: '管理面板',
  },
  datalab: {
    useNewStyle: SYSTEM_INFO.datalab[ENV],
    subIcon: 'bottle',
    href: '/datalab',
    name: 'Datalab',
    rbac: 'datalab',
    title: 'Datalab',
    title_cn: '自助分析',
    sys: '/datalab',
  },
  benchmark: {
    icon: '',
    actionIcon: '',
    subIcon: 'benchmark-icon',
    bubbleIntroMessageId: 'dhh_nav_bubble_benchmark_intro',
    name: 'Benchmark',
    title: 'Benchmark',
    title_cn: '行业基准',
    href: '/benchmark',
    sys: '/benchmark',
    rbac: 'benchmark',
    tipEn: 'NEW',
    tipCn: '新',
    tipExpiredDate: { start: '2024-09-01', end: '2025-06-30' },
  },
  aigallery: {
    icon: 'menu-merit',
    actionIcon: 'merit',
    useNewStyle: true,
    href: '/aigallery/home',
    sys: '/aigallery',
    rbac: 'aigallery',
    name: 'AI Gallery',
    title: 'AI Gallery',
    title_cn: 'AI Gallery',
    tipImg: newTagIcon,
    tipExpiredDate: { start: '2026-05-18', end: '2026-11-18' },
  },
  gamewiki: {
    useNewStyle: true,
    href: '/gamewiki',
    sys: '/gamewiki',
    rbac: 'gamewiki',
    name: 'GameWiki',
    title: 'GameWiki',
    title_cn: 'GameWiki',
  },
} as any;

export const navListConfig = Object.keys(baseNavListConfig).reduce((newObj: any, cur: any) => {
  return {
    ...newObj,
    [cur]: baseNavListConfig[cur],
    [`${cur}_pc`]: baseNavListConfig[cur],
  };
}, {});

export const defaultNavList = [
  {
    id: 1,
    title: '首页',
    icon: 'home-icon',
  },
  {
    id: 2,
    title: '经分',
    icon: 'merit',
    children: [
      {
        id: 1,
        icon: 'continuous-upward',
        title: 'Data Performance',
      },
      {
        id: 2,
        icon: 'bottle',
        title: 'DataLab',
      },
    ],
  },
  {
    id: 3,
    title: '情报',
    icon: 'intelligence',
    children: [
      {
        id: 1,
        icon: 'continuous-upward',
        title: 'Data Performance',
      },
      {
        id: 2,
        icon: 'bottle',
        title: 'DataLab',
      },
    ],
  },
  {
    id: 4,
    title: '舆情',
    icon: 'public',
    children: [
      {
        id: 1,
        icon: 'continuous-upward',
        title: 'Opinion',
      },
      {
        id: 2,
        icon: 'bottle',
        title: 'Marketing Hub',
      },
    ],
  },
  {
    id: 5,
    title: '管理看板',
    icon: 'manage-icon',
  },
];

export const defaultOptions = [
  { groupKey: 'Recent', value: 'strawberry', text: 'PUBGM' },
  { groupKey: 'Recent', value: 'cranberry', text: 'PUBGM社区' },
  { groupKey: 'Recent', value: 'raspberry', text: 'PUBG MOBILE' },
  { groupKey: 'Search', value: 'coca-cola', text: 'PUBG MOBILE: Konsekuens' },
  { groupKey: 'Search', value: 'pepsi-cola', text: 'PUBGM Community' },
];

export const defaultGroups = {
  Trending: 'Trending',
  Recent: 'Recent',
  Search: 'Search',
};

export const defaultGroupsCn = {
  Trending: '热门游戏',
  Recent: '历史',
  Search: '搜索',
};

const globalServiceRecipients = [
  'ivyyfchen@tencent.com',
  'haonanli@tencent.com',
  'rexzhhu@tencent.com',
  'DataBrain_B@tencent.com',
];

const emailLink = `mailto:${globalServiceRecipients.join(',')}`;

export const defaultHelpList = [
  {
    // 可以额外填写一些类名样式
    className: '',
    list: [
      // {
      //   icon: 'feedback-entrance',
      //   text: 'Feedback',
      //   text_cn: '反馈',
      //   link: '',
      //   eventName: 'feedback',
      // },
      {
        icon: 'message-tip',
        text: 'Help Center',
        text_cn: '帮助中心',
        link: '/help',
        link_cn: '/zh-CN/help',
      },
      {
        icon: 'service-icon',
        text: 'Online Service',
        text_cn: '在线客服',
        link: IS_GLOBAL ? emailLink : 'wxwork://message?username=DataBrain',
        className: 'seteing-out',
        eventName: 'onlineService',
      },
    ],
  },
  {
    className: 'seteing-out',
    type: 'guideList',
    listTitle: {
      text: 'Tutorial',
      text_cn: '新手引导',
    },
    list: [
      {
        icon: 'round',
        text: 'About DataBrain',
        text_cn: '关于数据大脑',
        link: '/help/user-guidelines/2',
        link_cn: '/zh-CN/help/user-guidelines/2',
      },
      {
        icon: 'round',
        text: 'Dashboard Beginner Guide',
        text_cn: '经分新手引导',
        eventName: 'dashboardGuideBox',
        link: '/help/user-guidelines/3',
        link_cn: '/zh-CN/help/user-guidelines/3',
      },
      {
        icon: 'round',
        text: 'Intelligence Beginner Guide',
        text_cn: '情报新手引导',
        eventName: 'intelligenceGuideBox',
        link: '/help/user-guidelines/8',
        link_cn: '/zh-CN/help/user-guidelines/8',
      },
      {
        icon: 'round',
        text: 'Opinions Beginner Guide',
        text_cn: '舆情新手引导',
        eventName: 'opinionGuideBox',
        link: '/help/user-guidelines/5',
        link_cn: '/zh-CN/help/user-guidelines/5',
      },
      {
        icon: 'round',
        text: 'G-POP Beginner Guide',
        text_cn: '管理看板新手引导',
        // link: '/help/user-guidelines/9',
        // link_cn: '/zh-CN/help/user-guidelines/9',
        link: GPOP_BEGINNER_GUIDE_DOC_URL,
        link_cn: GPOP_BEGINNER_GUIDE_DOC_URL,
      },
    ],
  },
];

export const AI_LIST = [
  {
    list: [
      {
        icon: 'ai-agent',
        text: 'DataBrain Agent',
        text_cn: 'DataBrain Agent',
        link: '/agent/home',
      },
      // {
      //   icon: 'information-cue',
      //   text: 'ChatBI',
      //   text_cn: 'ChatBI',
      //   link: '/aigc2/Action/GptAnalysis',
      // },
      {
        icon: 'hexagon-ai',
        text: 'AIGC Tools',
        text_cn: 'AIGC应用集',
        link: '/aigc/AITools',
        hidden: ['pro'].includes(ENV),
      },
      {
        icon: 'robot-small',
        text: 'ChatGPT',
        text_cn: 'ChatGPT',
        link: '/chatgpt',
      },
    ],
  },
];

export const defaultHelpUrl = '/zh-CN/help';

// 临时方案，针对Gloabl环境下，有以下三款游戏的舆情权限的用户，跳转到舆情Feeds页面
export const OPINIONFEEDSGAMES = [
  'edd35f56eec157e048662aa043c0017f9',
  'e925cb73ac298b96c84dc0dc31a2b2004',
  'e11000000344',
];

// 搜索下拉Trending状态key
export const TRENDING_KEY = 'search_pulldown_trending_status';

// GP的搜索结果类型
export const ENTITY_TYPE_GP = 'gpop-project';
